import { jsPDF } from "jspdf";
import { Hora } from "../Fecha";
import logopequeno from "../../../img/logopequeno.png";
import direccionfinal from "../../../img/direccionfinal.png";
import { createPdfLayout } from "./PdfLayout";

const PLANES = {
	"Plan Básico": {
		precio: "$35.000",
		etiquetaPrecio: "Valor Mensual",
		etiquetasExtra: ["Incluye IVA"],
		headerWidth: 100,
		items: [
			"-Declaracion de Formulario 29 (F29)",
			"-Revisión de Libro de Compras y de Ventas (Voucher)",
			"-Correos informativos y recordatorios",
			"-Asesorias",
		],
	},
	"Plan Emprende": {
		precio: "$60.000",
		etiquetaPrecio: "Valor Mensual",
		etiquetasExtra: ["Incluye IVA"],
		headerWidth: 100,
		items: [
			"-Declaracion de Formulario 29 (F29)",
			"-Revisión de Libro de Compras y de Ventas (Voucher)",
			"-Correos informativos y recordatorios",
			"-Carpeta Tributaria",
			"-Generación de E-Rut",
			"-Declaración de Ingresos (DIN)",
			"-Envío Libros Mensuales (compra y venta)",
			"-Rectificación sin cobros extra",
			"-Seguimiento de las Declaraciones Mensuales",
			"-Asesorias",
		],
	},
	"Plan Pyme": {
		precio: "$120.000",
		etiquetaPrecio: "Valor Mensual",
		etiquetasExtra: ["Incluye IVA"],
		headerWidth: 100,
		items: [
			"-Declaracion de Formulario 29 (F29)",
			"-Revisión de Libro de Compras y de Ventas (Voucher)",
			"-Correos informativos y recordatorios",
			"-Carpeta Tributaria",
			"-Generación de E-Rut",
			"-Declaración de Ingresos (DIN)",
			"-Envío Libros Mensuales (compra y venta)",
			"-Contabilidad Mensual",
			"-Rectificación sin cobros extra",
			"-Seguimiento de las Declaraciones Mensuales",
			"-Registro por Caja",
			"-Registro de Activo Fijo",
			"-Conciliación Bancaria",
			"-Acuse de Recibo (último día habil)",
			"-Asesorias",
		],
	},
	"Contrato Remuneraciones": {
		precio: "$15.000",
		etiquetaPrecio: "Valor Mensual por Trabajador",
		etiquetasExtra: ["Incluye IVA"],
		headerWidth: 150,
		items: [
			"-Elaboración de contratos de trabajo con sus actualizaciones y anexos",
			"-Cálculo de liquidaciones de sueldo",
			"-Cálculo de imposiciones y carga en PREVIRED",
			"-Control, cálculo y emisión de comprobantes de vacaciones.",
			"-Cálculo y elaboración de finiquitos (En caso de ser necesario)",
			"-Libro de remuneraciones si corresponde ",
		],
	},
};

const NOTIFICACIONES_ADICIONALES = [
	'Las partes acuerdan que toda gestión, solicitud de información, requerimiento de documentación, avisos de vencimientos, observaciones y demás comunicaciones relacionadas con los servicios contratados serán realizadas mediante correo electrónico enviado desde las casillas corporativas de Asesorías e Inversiones DN SpA, bajo su nombre de fantasía "denegocios.cl". Para todos los efectos legales y contractuales, las comunicaciones enviadas desde dominios corporativos asociados a denegocios.cl se entenderán válidamente efectuadas por el PRESTADOR.',
	"El CLIENTE declara conocer y aceptar que es su responsabilidad mantener actualizada su dirección de correo electrónico y revisar periódicamente su bandeja de entrada, correo no deseado (spam) y demás carpetas de recepción de mensajes, especialmente durante períodos asociados a declaraciones tributarias, declaraciones juradas, remuneraciones, Operación Renta, términos de giro, requerimientos de organismos públicos y cualquier otro servicio contratado.",
	"Asimismo, el CLIENTE se obliga a proporcionar de manera completa, veraz y oportuna toda la información y documentación requerida por el PRESTADOR, así como responder dentro de los plazos informados mediante correo electrónico. La falta de entrega de información, documentación y/o respuesta oportuna por parte del CLIENTE, así como la falta de revisión de las comunicaciones enviadas por el PRESTADOR, liberará a éste de toda responsabilidad respecto de retrasos, incumplimientos, multas, intereses, reajustes, recargos, sanciones, gastos, perjuicios o cualquier otra consecuencia derivada de dicha omisión.",
	"El PRESTADOR no será responsable por multas, intereses, reajustes, recargos, sanciones, citaciones, comparendos, fiscalizaciones, observaciones, requerimientos de antecedentes o cualquier otra actuación iniciada por el Servicio de Impuestos Internos (SII), Tesorería General de la República, Dirección del Trabajo, Municipalidades, organismos previsionales o cualquier entidad pública o privada, cuando éstas tengan su origen en la falta de revisión de los correos electrónicos enviados por el PRESTADOR, en la falta de respuesta del CLIENTE, en la entrega tardía, incompleta o incorrecta de información o documentación requerida, o en cualquier incumplimiento de las obligaciones de colaboración que correspondan al CLIENTE conforme al presente contrato.",
	"Adicionalmente, el CLIENTE podrá ser invitado a un canal informativo de WhatsApp administrado por denegocios.cl, destinado exclusivamente a complementar las comunicaciones enviadas por correo electrónico mediante la difusión de recordatorios, fechas relevantes, cambios normativos, avisos tributarios, laborales y demás información de interés relacionada con los servicios contratados. El CLIENTE declara conocer y aceptar que dicho canal tendrá carácter exclusivamente informativo, encontrándose deshabilitada la opción de responder mensajes o realizar comentarios.",
	"Las partes acuerdan expresamente que el canal informativo de WhatsApp constituye un medio complementario de comunicación y que el correo electrónico continuará siendo el medio formal, principal y válido para el envío de solicitudes, requerimientos, notificaciones y demás comunicaciones relacionadas con los servicios contratados.",
	"Las consultas, aclaraciones o requerimientos de apoyo podrán ser canalizados mediante los medios de comunicación habilitados por el PRESTADOR, pudiendo el CLIENTE solicitar reuniones de coordinación de hasta quince (15) minutos con el profesional asignado a su cuenta, sujetas a disponibilidad.",
	"Las partes reconocen expresamente que el correo electrónico constituye el principal medio de respaldo de las gestiones realizadas en virtud del presente contrato.",
];

export const ContratoContabilidad = (datos) => {
	let { nombre, rut, razon, rutEmpresa, fecha, nacionalidad, planContratado } = datos;
	if (fecha === "hoy") {
		fecha = Hora();
	}

	const plan = PLANES[planContratado];
	if (!plan) {
		alert("Error");
		return;
	}

	const doc = new jsPDF();
	const layout = createPdfLayout(doc, {
		logo: logopequeno,
		footer: direccionfinal,
	});

	const esRemuneraciones = planContratado === "Contrato Remuneraciones";
	const tituloServicio = esRemuneraciones ? "REMUNERACIONES" : "CONTABILIDAD";

	layout.writeMainTitle([
		{ text: "CONTRATO PRESTACIÓN SERVICIOS DE", x: 34 },
		{ text: `${tituloServicio}.`, x: 76 },
	]);

	layout.writeParagraph(
		`En Santiago de Chile, a ${fecha}, entre Asesorias e Inversiones DN SpA, Rut 77.526.796-8, domiciliado en Ahumada 254, oficina 806, Santiago Centro, en lo sucesivo los “PRESTADORES” y ${razon}, Rut: ${rutEmpresa}, representada legalmente por don/doña ${nombre}, Rut: ${rut}, de nacionalidad ${nacionalidad}, en lo sucesivo “EL CLIENTE”, se ha convenido el siguiente contrato de prestación de servicios.`
	);

	layout.writeSectionTitle("PRIMERO", 30);
	layout.writeParagraph(
		`El cliente contrata a Asesorias e Inversiones DN SpA, para que preste servicios en calidad de CONTADOR para realizar las labores que se indicarán para el ${planContratado} :`
	);
	layout.writeParagraph(`El ${planContratado} incluye lo siguiente:`);

	layout.renderPlanBox(planContratado, plan);

	layout.writeParagraph(
		"El valor indicado, corresponde al monto mensual que EL CLIENTE deberá cancelar todos los meses por la prestación de servicios. El valor indicado, será reajustado anualmente en función del IPC. El valor indicado, ya incluye IVA."
	);
	layout.writeParagraph(
		`El valor mensual anteriormente indicado, no incluye los Procesos ${
			esRemuneraciones
				? "Declaraciones Mensuales F29, Registro de Compras y Ventas, ni"
				: ""
		} de Renta (Declaraciones Juradas, F22 o Formulario de Declaración de Renta y otros relacionados). Estos procesos de Renta serán de cargo adicional y serán avizados a su debido momento. Más información de este punto puede ser visto en el articulo CUARTO.`
	);
	layout.writeParagraph(
		"El cliente podrá, previa conversación con el equipo de contabilidad de DeNegocios.cl, realizar un cambio de plan acorde a sus necesidades y requerimientos. Podrá encontrar un listado de precios y servicios en nuestra página web denegocios.cl/servicio-de-contabilidad/ para más detalles."
	);

	layout.newPage();

	layout.writeParagraph(
		"Adicionalmente y complementariamente el cliente podrá contratar los siguientes servicios:"
	);

	if (esRemuneraciones) {
		layout.writeSectionTitle("A) Servicio de Contabilidad Mensual", 103, 20);
		layout.writeParagraph(
			"Este servicio es complementario al servicio de remuneraciones.",
			{ indent: 20 }
		);
		layout.writeLine("Incluye:", { indent: 20, bold: true, gapAfter: 2 });
		layout.writeLine("1) Declaracion de Formulario 29 (F29).", { indent: 20, gapAfter: 2 });
		layout.writeLine("2) Revisión de Libro de Compras y de Ventas (Voucher)", { indent: 20, gapAfter: 2 });
		layout.writeLine("3) Correos informativos y recordatorios", { indent: 20, gapAfter: 2 });
		layout.writeLine("4) Asesorías.", { indent: 20, gapAfter: 2 });
		layout.writeRichLine(
			[
				{ text: "El valor de este servicio es desde los ", bold: false },
				{ text: "$35.000.- ", bold: true },
				{ text: "mensuales. Existen varios planes. Consultar.", bold: false },
			],
			{ indent: 20 }
		);
		layout.writeParagraph(
			"La contratación de este servicio es opcional, y aplica si el cliente desea que llevemos la contabilidad mensual de su empresa.",
			{ indent: 20, width: 160 }
		);
	} else {
		layout.writeSectionTitle("A) Servicio de Remuneraciones Mensual", 103, 20);
		layout.writeParagraph(
			"Este servicio es complementario al servicio de contabilidad mensual.",
			{ indent: 20 }
		);
		layout.writeLine("Incluye:", { indent: 20, bold: true, gapAfter: 2 });
		layout.writeLine("1) Elaboración de contratos de trabajo con sus actualizaciones y anexos.", {
			indent: 20,
			gapAfter: 2,
		});
		layout.writeLine("2) Cálculo de liquidaciones de sueldo", { indent: 20, gapAfter: 2 });
		layout.writeLine("3) Cálculo de imposiciones y carga en PREVIRED", { indent: 20, gapAfter: 2 });
		layout.writeLine("4) Control, cálculo y emisión de comprobantes de vacaciones", {
			indent: 20,
			gapAfter: 2,
		});
		layout.writeLine("5) Finiquitos. Libro de remuneraciones, si corresponde.", {
			indent: 20,
			gapAfter: 2,
		});
		layout.writeRichLine(
			[
				{ text: "El valor de este servicio es desde los ", bold: false },
				{ text: "$15.000.- ", bold: true },
				{ text: "por trabajador, de forma mensual. Consultar.", bold: false },
			],
			{ indent: 20 }
		);
		layout.writeParagraph(
			"La contratación de este servicio es opcional y complementaria.",
			{ indent: 20, width: 160 }
		);
	}

	layout.writeParagraph(
		"Los siguientes servicios pueden ser tomados adicionalmente, siempre y cuando no estén ya incluídos en el plan contratado inicialmente. Para saber qué servicios están en su plan, debe revisar el inicio del articulo PRIMERO."
	);

	layout.writeSectionTitle("A) Servicio Reviso tu PYME", 83, 20);
	layout.writeParagraph(
		"Revisión sobre la situación de la empresa entregando un diagnóstico idealmente en una llamada o reunión para aclarar las dudas y entregar una cotización para solucionar el problema.",
		{ indent: 20, width: 160 }
	);
	layout.writeLine("El valor de este servicio es de: $20.000.-", { indent: 20 });

	layout.writeSectionTitle("B) Servicio de Rectificación de F29", 93, 20);
	layout.writeLine("El valor de este servicio es de: $20.000 por mes.", { indent: 20 });

	layout.writeSectionTitle("C) Servicio de Declaraciones F29 Pendientes", 110, 20);
	layout.writeLine("El valor de este servicio es de: $20.000 por mes.", { indent: 20 });

	layout.writeSectionTitle("D) Otros Servicios no incluídos en Plan", 100, 20);
	layout.writeParagraph(
		"Los siguientes documentos: Carpeta tributaria, f30, Declaraciones de Ingresos “DIN” (hasta 3 documentos DIN para un respectivo mes), generación de cédulas E-Rut, comprobante de vacaciones, certificados y comprobantes varios, facturas, notas de crédito y débito, boletas de productos y/o servicios, boletas de honorarios; así como cualquier otro documento que no haya sido mencionado en los elementos básicos incluídos en el plan que usted contrata, tendrán un valor adicional de $5.000 cada uno. Por complejidad el F30-1 tendrá un valor de $10.000 cada uno.-",
		{ indent: 20, width: 160 }
	);

	layout.writeSectionTitle("SEGUNDO: DEL NO PAGO", 65);
	layout.writeParagraph(
		"Si bien, indistintamente de lo siguiente, se aplicará lo descrito en los articulos QUINTO, SEXTO y SEPTIMO, es importante mencionar que la prestación de servicios se realizará continuamente de forma independientemente del pago de estos por un plazo máximo de hasta 3 meses. Si el cliente a pesar de este plazo decide no pagar, se le dará aviso de corte del servicio y este no continuará hasta que el cliente haya cancelado lo adeudado. Las no declaraciones realizadas a tiempo involucran multas e intereses por parte del SII, que no serán asumidas por DeNegocios.cl de tratarse de declaraciones atrasadas producto del no pago de servicios previos."
	);

	layout.newPage();

	layout.writeSectionTitle("TERCERO", 30);
	layout.writeParagraph("No están incluidos dentro de los servicios señalados anteriormente:");
	layout.writeLine("- Recepción de dinero y pago de Impuestos o Cotizaciones.", { indent: 5, gapAfter: 2 });
	layout.writeLine("- Retiro de Documentos.", { indent: 5, gapAfter: 2 });
	layout.writeParagraph(
		"- Contratos Laborales Especiales o con cláusulas particulares que requieran la intervención de un abogado para su redacción o que estén por fuera de los modelos actualmente estandarizados para la gran mayoría de las empresas.",
		{ indent: 5, width: 185 }
	);
	layout.writeLine(
		"- Trámites o Procesos relacionados a la Inspección del Trabajo, dígase F30, F30-1 y similares.",
		{ indent: 5, gapAfter: 2 }
	);
	layout.writeLine(
		"- Representación ante el Servicio de Impuestos Internos ante fiscalizaciones y otros.",
		{ indent: 5, gapAfter: 2 }
	);
	layout.writeLine(
		"- Emisión de Facturas y otros Documentos Tributarios Electrónicos o en Físico.",
		{ indent: 5, gapAfter: 2 }
	);
	layout.writeLine(
		"- Trámites electrónicos o presenciales ante la Inspección del Trabajo, AFC,Fonasa, Isapres, AFP.",
		{ indent: 5, gapAfter: 2 }
	);
	layout.writeParagraph(
		"- Preparación de Inventarios, Balances, auditorias, defensorías tributarias, confección de declaraciones juradas, confecciones de declaraciones de Rentas, reclamación de impuestos.",
		{ indent: 5, width: 185 }
	);
	layout.writeParagraph(
		"Dado el caso, se pagarán como extraordinarios los trabajos anteriores si Asesorias e Inversiones DN SpA acepta realizar las gestiones. Esto, previo acuerdo por escrito entre las partes."
	);

	layout.writeSectionTitle("CUARTO", 30);
	layout.writeParagraph(
		"En lo que respecta al período que llamaremos “Declaración de Renta”. Esto es: El Balance Anual, la Declaración de Impuesto a la Renta F22, las declaraciones Juradas de Horarios, Sueldos y Retiros, además de la Determinación de Capital Propio Tributario, Renta Líquida Imponible y FUT, documentos y libros necesarios para la Confección del F/22 Declaración de Renta; y otros relacionados a la “Declaración de Renta”."
	);
	layout.writeParagraph(
		"Lo anterior, podrá ser tomado por EL CLIENTE como servicio adicional prestado por Asesorias e Inversiones DN SpA. Esto es opcional y no involucra una obligación para el cliente. Si es que el cliente decide aceptar este servicio adicional, este tendrá un costo adicional desde $200.000 para empresa y no tiene relación alguna con el costo del Servicio mensual. Las condiciones de este servicio, así como su valor final, serán confirmados por Asesorias e Inversiones DN SpA. Por lo demás, el cliente podrá consultar por ellos y contratar en cualquier momento. Asesorias e Inversiones DN SpA no se hará responsable por multas asociadas a la no presentación de “Declaración de Renta” asociadas a la No Contratación de este Servicio con nuestra empresa."
	);

	layout.writeSectionTitle("QUINTO", 30);
	layout.writeParagraph(
		"Los honorarios del servicio serán informados por el prestador a su debido tiempo, esto a lo menos 5 días antes del día 30 de cada mes. Los honorarios del servicio deberán ser cancelados directamente a Asesorias e Inversiones DN SpA como máximo los días 5 del mes siguiente a lo informado, en dinero efectivo directamente en las oficinas del prestador, transferencia o depósito a la cuenta que el prestador indique."
	);
	layout.writeParagraph(
		"Si el pago se realiza vía transferencia o depósito, deberán ser realizados a la siguiente cuenta:"
	);
	layout.writeLine("BANCO: BANCO ESTADO", { indent: 10, bold: true, gapAfter: 2 });
	layout.writeLine("Nombre Empresa: ASESORIAS E INVERSIONES DN SpA", {
		indent: 10,
		bold: true,
		gapAfter: 2,
	});
	layout.writeLine("Rut: 77.526.796-8", { indent: 10, bold: true, gapAfter: 2 });
	layout.writeLine("Tipo de Cuenta: Chequera electrónica // cuenta vista", {
		indent: 10,
		bold: true,
		gapAfter: 2,
	});
	layout.writeLine("Número de cuenta: 90270930912", { indent: 10, bold: true, gapAfter: 2 });
	layout.writeLine("Correo: pagos@denegocios.cl", { indent: 10, bold: true, gapAfter: 2 });
	layout.writeParagraph(
		"Asesorias e Inversiones DN SpA, tras recibir el pago, podrá emitir una factura por el servicio."
	);

	layout.newPage();

	layout.writeParagraph(
		"Las partes convienen en que las tarifas indicadas en la tabla única de este contrato, esto es en el Artículo Segundo, pueden sufrir cambios en el tiempo. Estos cambios en la tarifa serán convenidos por las partes de común acuerdo, en el entendido que en caso de que las partes no lograran llegar a un acuerdo en el incremento de la prestación, el presente contrato podrá darse por terminado sin responsabilidad de alguna para las partes."
	);

	layout.writeSectionTitle("SEXTO:VIGENCIA", 50);
	layout.writeParagraph(
		"La vigencia de este Contrato será por 6 meses (seis meses) de corrido, iniciando a partir del día en el que este documento se firme. Tendrá renovación automática por períodos iguales de tiempo, si es que ninguna de las partes se proclama. Asimismo el PRESTADOR se obliga a entregar al CLIENTE a más tardar el día en que sufra efectos la terminación a que se refiere esta cláusula o la rescisión a que se refiere la cláusula Décima Quinta de este contrato, toda la documentación e información confidencial del CLIENTE que tenga en su poder con motivo de LOS SERVICIOS, así como un informe detallado de todas las acciones ejercidas en cada uno de los asuntos que le hayan sido encomendados por virtud de este contrato."
	);
	layout.writeParagraph(
		"El presente contrato podrá ponerse término por ambas partes con 15 días corridos de anticipación vía escrita, para la entrega de la información por parte de Asesorias e Inversiones DN SpA., y por parte del cliente el pago de los servicios efectuados hasta esa fecha."
	);

	layout.writeSectionTitle("SEPTIMO: CLAUSULA PENAL ", 70);
	layout.writeParagraph(
		"El no pago de cualquiera de los montos señalados en la cláusula cuarta autorizará a Asesorías e Inversiones DN SpA, Rol único tributario 77.526.796-8, para que, en caso de retardo, mora o incumplimiento de las obligaciones contraídas en documentos como contratos, facturas, órdenes de compra, solicitudes de compra, guías de pedidos, cartas de porte, pagarés, letras de cambio u otros, mis datos personales y los derivados de dichos documentos sean ingresados, procesados, tratados y comunicados a terceros sin restricciones en registros o bancos de datos de sistemas de información comercial. Además, dará derecho a Asesorías e Inversiones DN SpA a poner término unilateralmente a la prestación de los servicios objeto de este contrato, liberando al cliente de la responsabilidad procesal posterior a su incumplimiento, aceptando la renuncia al mandato judicial en las causas señaladas en la cláusula primera. Asimismo, facultará a la empresa a exigir el cobro del total adeudado como obligación pura y simple, sin perjuicio de las demás acciones legales que correspondan."
	);

	layout.writeSectionTitle("OCTAVA.- NO EXCLUSIVIDAD PARA EL PRESTADOR.", 120);
	layout.writeParagraph(
		"Queda expresamente pactado que el presente contrato no crea exclusividad entre las partes, por lo que sí es voluntad del CLIENTE, éste podrá contratar cualquier servicio igual o similara los proporcionados por EL PRESTADOR, con la persona o personas, físicas o morales, nacionales o extranjeras que a sus intereses convenga, sin necesidad de notificarlo al PRESTADOR."
	);

	layout.writeSectionTitle("NOVENA.- CONFIDENCIALIDAD.", 75);
	layout.writeParagraph(
		"EL PRESTADOR y su personal, al que el CLIENTE otorgue acceso para la prestación de LOS SERVICIOS, previo a la firma del presente contrato y durante su vigencia, tendrán acceso a información del CLIENTE que se considerará confidencial. Por ello, el PRESTADOR se compromete a no divulgar, por ningún medio ni a ninguna persona, dicha información, ni los datos y resultados derivados de LOS SERVICIOS, salvo autorización expresa y escrita del CLIENTE."
	);
	layout.writeParagraph(
		"La obligación del PRESTADOR, descrita en el párrafo anterior, tendrá efecto desde la firma del presente contrato y durante su vigencia, así como un año posterior a la terminación de la relación de prestación de servicios entre las partes, garantizando la protección de la confidencialidad de los intereses del CLIENTE."
	);
	layout.writeParagraph(
		"El PRESTADOR se compromete a hacer extensivas estas obligaciones a sus empleados o a cualquier persona que deba acceder a información confidencial. Asimismo, deberá adoptar medidas necesarias para garantizar que estas personas cumplan estrictamente con lo acordado. En caso contrario, el PRESTADOR o las personas involucradas serán responsables de lo que disponga la legislación aplicable."
	);

	layout.newPage();

	layout.writeSectionTitle("DÉCIMA.- INDEPENDENCIA DE LAS PARTES.", 105);
	layout.writeParagraph(
		"El presente contrato no presentade manera tácita o expresa, cualquier tipo de alianza, sociedad, asociación, asociación en participación, o transferencia de acciones, o participación de alguna en la capital social y/o patrimonio según aplique, de cada una de las partes, así como tampoco aplica una relación laboral entre éstas, por lo que se manifiesta en este acto la independencia de ambas partes respecto a sus derechos y obligaciones derivados de la celebración de este contrato, en relación con terceros."
	);
	layout.writeParagraph(
		"No obstante lo anterior, el PRESTADOR se obliga a proporcionar los servicios objeto de este contrato, de la manera que EL CLIENTE se lo solicite o instruye y siempre en escrito apego a las leyes y procedimientos que en su caso sean aplicables."
	);

	layout.writeSectionTitle("DÉCIMA PRIMERA.- NOTIFICACIONES.", 80);
	layout.writeParagraph(
		"Cualquier tipo de notificación entre las partes deberá ser por escrito vía correo electrónico, copiando expresamente a contabilidad@denegocios.cl y a contacto@denegocios.cl."
	);
	NOTIFICACIONES_ADICIONALES.forEach((texto) => layout.writeParagraph(texto));

	layout.writeSectionTitle("DÉCIMA SEGUNDA.- REVISIONES Y AUDITORÍAS.", 115);
	layout.writeParagraph(
		"Las partes convienen que el CLIENTE podrá en todo momento efectuar, por medio de las personas que estimen conveniente, revisiones, auditorías, verificaciones y podrás solicitar al PRESTADOR la elaboración y entrega de todo tipo de reportes y controles relacionados con la prestación de LOS SERVICIOS y el PRESTADOR se obliga a dar todas las facilidades necesarias para la realización de las revisiones, auditorías y verificaciones y entrega al CLIENTE en la forma y plazo que éste solicite los citados reportes y/o controles."
	);

	layout.writeSectionTitle("DÉCIMO TERCERA.- MODIFICACIONES AL CONTRATO.", 130);
	layout.writeParagraph(
		"Este contrato no podrá ser modificado o alterado, excepto mediante acuerdo por escrito, firmado por ambas partes."
	);

	layout.writeSectionTitle("DÉCIMO CUARTA.- MANIFESTACIÓN DE LA VOLUNTAD.", 130);
	layout.writeParagraph(
		"El presente contrato constituye el acuerdo de voluntades total y final entre las partes, por lo que cualquier aviso, oferta, comunicación, contrato, convenio o acuerdo en general sea verbal y/o escrito, adoptado entre las partes con anterioridad a la firma del presente, queda a partir de la fecha de firma de este instrumento sin valor alguno."
	);

	layout.writeSectionTitle("DÉCIMO QUINTA", 48);
	layout.writeParagraph(
		"Las multas e intereses por el pago fuera de plazo de las obligaciones tributarias y previsionales del cliente serán de su exclusiva responsabilidad, no así, ya sea por olvido u omisión involuntaria de parte de Asesorias e Inversiones DN SpA, quien será este último el que costeara dichos cargos."
	);

	layout.writeClosingSection(
		"DÉCIMA SEXTA.- JURISDICCIÓN.-",
		80,
		[
			"Para la interpretación y cumplimiento de este contrato, las partes se someten expresamente a las leyes y tribunales de la ciudad de Santiago, Chile, renunciando a cualquier otro fuero que pudiera corresponderles por razón de sus domicilios presentes o futuros o por cualquierotra causa.",
			`Enteradas de su contenido y alcance legal y no existiendo error, dolo, mala fe o violencia, las partes firman de conformidad, por duplicado el presente Contrato para el servicio de Contabilidad ${planContratado}, en la ciudad de Santiago, Chile a ${fecha}, fecha en la cual entra en vigor.`,
		],
		{ razon, rutEmpresa, nombre, rut }
	);

	layout.finish();
	doc.save(`Contrato Contabilidad para ${razon}.pdf`);
};
